import { Controller } from "@hotwired/stimulus"

// Highlights the search term inside a rich-text content area on expand.
// Walks only text nodes so HTML attributes and tags are never modified.
export default class extends Controller {
  static targets = ["content"]
  static values  = { term: String }

  onToggle(event) {
    if (event.target.open) this.#applyHighlight()
  }

  #applyHighlight() {
    const term = this.termValue.trim()
    if (!term || term.length < 2) return
    if (!this.hasContentTarget) return

    const content = this.contentTarget
    if (content.dataset.highlighted === "true") return

    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    const regex   = new RegExp(escaped, "gi")

    this.#walkTextNodes(content, regex)
    content.dataset.highlighted = "true"
  }

  #walkTextNodes(root, regex) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null)
    const nodes  = []

    while (walker.nextNode()) nodes.push(walker.currentNode)

    nodes.forEach(node => {
      if (!regex.test(node.textContent)) return
      regex.lastIndex = 0

      const wrapper  = document.createElement("span")
      wrapper.innerHTML = node.textContent.replace(
        regex,
        match => `<mark class="search-highlight">${match}</mark>`
      )
      node.parentNode.replaceChild(wrapper, node)
    })
  }
}
